import moment from 'moment';

export const globalFunctionsMixin = {
    methods: {
      formatDate(date,formato = 'DD/MM/YYYY') {
        return moment(date).format(formato); 
      },

      truncateText(text, maxLength, useEllipsis = false) {
        if (!text) return '';
        if (text.length <= maxLength) {
          return text
        }
        const truncated = text.slice(0, maxLength)
        return useEllipsis ? truncated + '...' : truncated
      },

      leerLocalStorage(key) {
        const value = localStorage.getItem(key);
        if (!value || value==='null') {
            return {};
        }
        try {
            return JSON.parse(value);
        } catch (error) {
            return {};
        }
      }

    },
};